import {Injectable} from '@angular/core';
import { HttpUrlEncodingCodec } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class UrlService {

  constructor() {
  }

  goToUrl(path: string): void {
    window.location.replace(path);
  }

  openUrlInNewTab(url: string): void {
    window.open(url, '_blank');
  }

  getHref(): string {
    return window.location.href;
  }

  getTenantFromUrl(): string {
    return window.location.pathname.split('/')[1];
  }

  encodeUrl(url: string): string {
    const codec = new HttpUrlEncodingCodec();
    return codec.encodeValue(url);
  }

  getEnvironmentFromUrl(): string {
    return window.location.href.split('.')[0].split('/')[2];
  }

  private getADOBaseUrl(): string {
    const currentEnv = this.getEnvironmentFromUrl();

    if (currentEnv === 'preprod' || currentEnv === 'sit' || currentEnv === 'dev') {
      return 'https://dev.azure.com/TemCloudTechSolns/cloud2.0auto';
    } else if (currentEnv === 'utp') {
      return 'https://dev.azure.com/utp-saas2/saas2.0';
    } else {
      return 'https://dev.azure.com/TemCloudTechSolns/ClientDelivery';
    }
  }

  private buildADOUrl(path: string, queryParam: string, value: string): string {
    if (!value) {
      return '';
    }
    return `${this.getADOBaseUrl()}${path}?${queryParam}=${value}`;
  }

  buildADOPipelineUrl(pipelineId: string): string {
    return this.buildADOUrl('/_build', 'definitionId', pipelineId);
  }

  buildJobResultsUrl(buildId: string): string {
    return this.buildADOUrl('/_build/results', 'buildId', buildId);
  }
}
